import * as Sentry from '@sentry/browser'
import debounce from 'lodash/debounce'
import pick from 'lodash/pick'
import { AirDNARequest, AirDNALoaded } from '../constants/trackingEvents'
import {
  PREPARE_AIRDNA_REQUEST,
  FETCH_AIRDNA_REQUEST,
  FETCH_AIRDNA_SUCCESS,
  FETCH_AIRDNA_FAILURE,
  SET_AIRDNA_SETTINGS,
} from './actionTypes'
import { fetchAirDna as tokenFetchResource } from '../api/mikasa/token_requests'
import { fetchAirDna as fetchResource } from '../api/mikasa/requests'
import { flashNotification } from './notification'
import { ERRORS } from '../constants/messages'
import { updateBuyerInfo } from './buyerInfo'
import { dispatchEvent } from '../helpers/tagManager'
import { execute } from '../vendor/recaptcha'

export const prepareStateKey = stateKey => ({
  type: PREPARE_AIRDNA_REQUEST,
  stateKey,
})

const fetchWithMethod =
  fetchMethod =>
  (stateKey, { address, zipcode }) =>
  async (dispatch, getState) => {
    const params = { address, zipcode }

    dispatch({
      type: FETCH_AIRDNA_REQUEST,
      stateKey,
    })

    dispatchEvent(AirDNARequest)

    let validationToken

    try {
      validationToken = await execute({ action: 'request_rental_potential' })
    } catch (e) {
      console.error(e)
      Sentry.captureException(e)
    }

    try {
      const response = await fetchMethod({
        ...params,
        validationToken,
      })
      const { propertyStats: stats } = response.data
      dispatch({
        type: FETCH_AIRDNA_SUCCESS,
        stateKey,
        params,
        settings: {
          pricePerNight: Math.round(stats.adr.ltm * 0.7),
          nightsPerMonth: Math.round(stats.occupancy.ltm * 30 * 0.7),
        },
        data: pick(response.data, 'propertyStats'),
      })
      dispatchEvent(AirDNALoaded)
    } catch (error) {
      dispatch({
        type: FETCH_AIRDNA_FAILURE,
        stateKey,
        error,
      })

      dispatch(
        flashNotification({
          message: [ERRORS.defaultHeadline, ERRORS.defaultMessage],
          messageType: 'error',
        })
      )
    }
  }

export const fetchAirDna = fetchWithMethod(fetchResource)

export const tokenFetchAirDna = fetchWithMethod(tokenFetchResource)

export const updateSettings = (stateKey, settings) => dispatch => {
  dispatch({
    type: SET_AIRDNA_SETTINGS,
    stateKey,
    settings,
  })

  dispatch(persistSettings(stateKey))
}

const withDispatchUpdate = debounce(
  (dispatch, ...args) => dispatch(updateBuyerInfo(...args)),
  3000
)

const persistSettings = stateKey => (dispatch, getState) => {
  const { nightsPerMonth, pricePerNight } = getState().airDna[stateKey].settings
  withDispatchUpdate(dispatch, {
    nightsPerMonth,
    strPricePerNight: pricePerNight,
  })
}
